module.exports = __webpack_public_path__ + "static/media/Himani Soap Ad.e5275acd.jpg";